import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import CustomPaginationTable from './CustomPaginationTable';
import IconFilledBag from '../../Icons/IconFilledBag';
import IconSaving from '../../Icons/IconSaving';
import IconCar from '../../Icons/IconCar';

import NoData from '../../components/NoData';
import { AuthContextType, SaldoData } from '../../types/Types';
import { AppContextType } from '../../store/AppContext';
import { StorageHelper } from '../../utils/StorageHelper';
import { StylesSwapHelper } from '../../utils/StylesSwapHelper';
import routerLoader from '../../i18n/router';

interface Props {
  dataUser: AuthContextType;
  ahorrado: number;
  view: boolean;
  dataApp: AppContextType;
  backError: boolean;
  saldoData: SaldoData[];
}

const SaldoCaprabo: FC<Props> = (props) => {
  const { t } = useTranslation();
  const { dataUser, ahorrado, view, dataApp, backError, saldoData } = props;

  return (
    <>
      {(() => {
        const isApp = dataUser.user.isApp === 'true';
        const isEcommerceBot = StorageHelper.isEcommerceBot();
        StylesSwapHelper.swapStyleIfApp(isApp || isEcommerceBot);
        return (
          <>
            <section className="o-section--no-padding-top section--background">
              <div className="container">
                <div className="cabecera-seccion saldoCaprabo">
                  <div className="titulo-seccion">
                    <h1 className="titulo-seccion__title">
                      {t('saldo.title')}
                    </h1>
                    {/* eslint-disable-next-line consistent-return */}
                    {(() => {
                      if (view) {
                        return (
                          <>
                            <div className="titulo-seccion__num">
                              <p className="saldo">
                                {ahorrado}{' '}
                                <sup>
                                  {dataUser.user.moneda === 'euro'
                                    ? t('euro')
                                    : t('cc')}
                                </sup>
                              </p>
                              <p className="text">{t('saldo.savedMoney')}</p>
                            </div>
                          </>
                        );
                      }
                      return false;
                    })()}
                  </div>

                  <div className="links-cabecera">
                    <div className="icon-link-block u-margin-bottom-small u-display-none-only-mobile-tablet">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                        href={routerLoader.LoadRouterByPath(
                          'ahorros',
                          dataApp.lang,
                        )}
                        className="icon-link u-align-items-baseline"
                      >
                        <div className="icon icon-medium icon--grey ">
                          <IconSaving />
                        </div>
                        <span className="u-font-small u-text-brand u-text-decoration-underline">
                          {t('saldo.mySavings')}
                        </span>
                      </a>
                    </div>
                    <div className="icon-link-block u-margin-bottom-small u-display-none-only-mobile-tablet">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                        href={routerLoader.LoadRouterByPath(
                          'compras-y-tickets',
                          dataApp.lang,
                        )}
                        className="icon-link u-align-items-baseline"
                      >
                        <div className="icon icon-medium icon--grey ">
                          <IconFilledBag />
                        </div>
                        <span className="u-font-small u-text-brand u-text-decoration-underline">
                          {t('saldo.myShopping')}
                        </span>
                      </a>
                    </div>
                    {!isApp && (
                      <div className="icon-link-block">
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a
                          href={`${process.env.REACT_APP_CAPRABO_CASA}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="icon-link u-align-items-baseline"
                          title="Super online, enlace, abre una nueva ventana"
                        >
                          <div className="icon icon-medium icon--grey ">
                            <IconCar />
                          </div>
                          <span className="u-font-small u-text-brand u-text-decoration-underline">
                            {t('caprabo.saldo.capraboacasa')}
                          </span>
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>

            <section
              className={`o-section--large saldoCaprabo ${
                saldoData.length === 0 ? 'marginNoData' : ''
              }`}
            >
              <div className="container-inner__small">
                {(() => {
                  if (!backError) {
                    return <CustomPaginationTable data={saldoData} />;
                  }
                  return (
                    <NoData>
                      <div className="mensaje">
                        <p>{t('saldo.noRecords')}</p>
                      </div>
                    </NoData>
                  );
                })()}
              </div>
            </section>
          </>
        );
      })()}
    </>
  );
};

export default SaldoCaprabo;
